import dynamic from 'next/dynamic'
import { type CmsMappedComponents, type ModalContent } from '@/features/cms/components/CMS/types'

export const DynamicEntryModal = dynamic(
  async () =>
    (await import('@/features/cms/components/CMS/components/Modals/EntryModal')).EntryModal,
  { ssr: false },
)

export const modalCmsComponents: CmsMappedComponents<ModalContent['content_type_id']> = {
  entry_modal: DynamicEntryModal,
}
